import { useEffect, useState } from "react"
import Loading from "src/components/Loading";
import { get, post } from "src/services/HttpClient"
import { notify } from "src/services/Notification/Notification";
import { homeURL } from "src/settings/config";

export default function SidebarFooter() {
    const [superAccessToken, setSuperAccessToken] = useState()



    useEffect(() => {
        setSuperAccessToken(localStorage.getItem("super_access_token"))
    }, [])


    const returnToSuperAdminView = async () => {
        localStorage.setItem("access_token", superAccessToken);
        localStorage.removeItem("super_access_token")
        window.location.href = "/app/setting/user-management/user"

    }

    return (
        <>
            <div className="flex-shrink-0 p-2 max-h-14">
                {
                    superAccessToken
                    &&
                    <button
                        className="flex items-center justify-center w-full px-4 py-2 space-x-1 font-medium tracking-wider uppercase bg-gray-100 hover:bg-gray-200 transition-all ease-in-out duration-200 border rounded-md focus:outline-none focus:ring"
                        onClick={returnToSuperAdminView}
                    >
                        <span> بازگشت به داشبورد ادمین </span>
                    </button>
                }
            </div>
        </>
    )
}